// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/message.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { messagesApi } from "../../api/messages";
import type { Message } from "../../api/types";
// override-block:imports BEGIN
// CHG-1294 — per-page RBAC gate wiring (consumes GATE_CATALOG).
import { GATE_CATALOG } from "../../auth/gateCatalog";
import { toGate } from "../../auth/toGateProp";
// CHG-1330 — bulk-tag UX (closes DRIFT-648).
import { openBulkTagDialog } from "../../lib/bulk-tag-dialog";
// override-block:imports END

// override-block:helpers BEGIN
// override-block:helpers END

export const messageListConfig: ListPageConfig<Message> = {
  title: "Messages",
  subtitle: "Outbound communications — drafts, scheduled sends, dispatched broadcasts.",
  queryKey: ["messages", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search }) =>
    messagesApi.listMessages({ page, pageSize, sortField, sortDirection, search }),
  defaultSort: { field: "created_at", direction: "desc" },
  pageSize: 50,
  rowHref: "/messages/{id}",
  search: { enabled: true, placeholder: "Search messages by subject or audience…" },
  emptyState: {
    title: "No messages yet",
    subtitle: "Compose your first broadcast or wait for the next automation to fire.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    // CHG-1294 — Edit + Duplicate header actions; both forward-promised
    // (entity-hint.primary_actions.edit cites experience.form.message-edit
    // not in v2; secondary_actions.duplicate cites duplicateMessage not
    // wired). onClick is a no-op until those land.
    {
      id: "edit",
      label: "Edit",
      variant: "secondary",
      onClick: () => undefined,
      permissionGate: toGate(GATE_CATALOG.message_list["edit"], "disable"),
    },
    {
      id: "duplicate",
      label: "Duplicate",
      variant: "ghost",
      onClick: () => undefined,
      permissionGate: toGate(GATE_CATALOG.message_list["duplicate"], "hide"),
    },
    // override-block:header-actions END
  ],
  bulkActions: [
    {
      id: "tag",
      label: "Tag selected",
      variant: "primary",
      permission: "alora-giving.tag.attach",
      permissionFallback: "hide",
      onAction:
        // override-block:bulk-action-tag BEGIN
        (ids) => openBulkTagDialog({ entityType: "message", ids }),
        // override-block:bulk-action-tag END
    },
  ],
  columns: [
    { field: "intent_title", label: "Intent Title", type: "text", sortable: true },
    { field: "kind", label: "Kind", type: "text", sortable: true },
    { field: "status", label: "Status", type: "text", sortable: true },
    { field: "channel_plan", label: "Channel Plan", type: "text" },
    { field: "scheduled_at", label: "Scheduled At", type: "relative-date", sortable: true },
    { field: "created_at", label: "Created At", type: "relative-date", sortable: true },
  ],
};
